/**
 * Is image source
 */
export default function src(url) {
  return /^(https?:)?\/\/|data:image/.test(url);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/validate/src.js
// module id = 20
// module chunks = 0 1 2 3 4 5 6 7